import React from "react";

function App() {
  return (
    <div style={{ fontFamily: "Arial, sans-serif", lineHeight: "1.6", color: "#333" }}>
      
      {/* Hero Section */}
      <header style={{ backgroundColor: "#003366", color: "white", textAlign: "center", padding: "120px 20px" }}>
        <h1 style={{ fontSize: "3rem", fontWeight: "bold" }}>💦 KJS Supreme Pressure Washing</h1>
        <p style={{ fontSize: "1.2rem", maxWidth: "700px", margin: "20px auto" }}>
          Professional Pressure Washing Services Across Central Florida – Residential & Commercial
        </p>
        <a
          href="#contact"
          style={{
            backgroundColor: "#FF6B00",
            color: "white",
            padding: "15px 30px",
            borderRadius: "5px",
            textDecoration: "none",
            fontWeight: "bold",
            display: "inline-block",
            marginTop: "20px",
          }}
        >
          Get Your Free Quote
        </a>
      </header>

      {/* Services Section */}
      <section id="services" style={{ padding: "80px 20px", textAlign: "center", backgroundColor: "#f9f9f9" }}>
        <h2>Our Services</h2>
        <p style={{ maxWidth: "800px", margin: "20px auto" }}>
          We provide high-quality, eco-friendly pressure washing solutions for homes and businesses.  
          No job is too big or small!
        </p>
        <ul style={{ listStyle: "none", padding: 0, marginTop: "40px", fontSize: "1.1rem" }}>
          <li>🏠 House Washing</li>
          <li>🚗 Driveways & Sidewalks</li>
          <li>🌴 Patio, Pool Deck & Roof Cleaning</li>
          <li>🏢 Commercial Pressure Washing</li>
          <li>🪟 Gutter & Exterior Cleaning</li>
        </ul>
      </section>

      {/* Service Areas */}
      <section id="areas" style={{ padding: "60px 20px", textAlign: "center" }}>
        <h2>Service Areas</h2>
        <p style={{ maxWidth: "900px", margin: "0 auto" }}>
          We proudly serve Central Florida including: Ocala, Orlando, Apopka, Deltona, Sanford, Winter Park,
          Mt Dora, Daytona Beach, Winter Garden, Tavares, Winter Springs, DeBary, Osteen, Zellwood,
          Casselberry, New Smyrna Beach, Altamonte Springs, Wekiwa Springs, and surrounding areas.
        </p>
      </section>

      {/* About Section */}
      <section id="about" style={{ backgroundColor: "#f2f2f2", padding: "80px 20px", textAlign: "center" }}>
        <h2>About KJS Supreme Pressure Washing</h2>
        <p style={{ maxWidth: "800px", margin: "20px auto" }}>
          KJS Supreme Pressure Washing is a locally-owned business dedicated to providing professional, reliable,
          and eco-friendly pressure washing services. Our team uses top-quality equipment to ensure your property
          looks its absolute best.
        </p>
        <p style={{ maxWidth: "800px", margin: "20px auto" }}>
          Residential, commercial, and industrial projects are all handled with care and expertise.  
          Customer satisfaction is our top priority.
        </p>
      </section>

      {/* Contact Section */}
      <section
        id="contact"
        style={{
          backgroundColor: "#003366",
          color: "white",
          padding: "80px 20px",
          textAlign: "center",
        }}
      >
        <h2>Contact Us Today</h2>
        <p style={{ fontSize: "1.2rem" }}>📞 Call: <a href="tel:+14075557890" style={{ color: "white" }}>(407) 555-7890</a></p>
        <p>💬 <a href="https://wa.me/14075557890" target="_blank" rel="noreferrer" style={{ color: "white" }}>WhatsApp Chat</a></p>
        <p>🌐 <a href="https://kjsupremepressurewashing.com" target="_blank" rel="noreferrer" style={{ color: "white" }}>Visit Our Website</a></p>
        <p>📍 Serving all of Central Florida</p>
      </section>

      {/* Footer */}
      <footer style={{ textAlign: "center", padding: "20px", background: "#222", color: "#aaa" }}>
        © {new Date().getFullYear()} KJS Supreme Pressure Washing. All rights reserved.
      </footer>
    </div>
  );
}

export default App;
